import Notifications from "vue-notification";

require('../config.js');
import Vue from 'vue';
import router from './routes'
import store from './store'
import { i18n, changeLanguage } from '../plugins/i18n.js'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueCookies from 'vue-cookies'
import Password from 'vue-password-strength-meter'
import Translate from '../admin/components/Translate';

Vue.directive('click-outside', {
    bind(el, { value }) {
        el._handler = e => {
            if (!el.contains(e.target)) {
                value(e);
            }
        };

        // *** Using capturing ***
        document.addEventListener('click', el._handler, { capture: true });
    },

    unbind(el) {
        document.removeEventListener('click', el._handler, { capture: true });
    },
});

let base_url = document.head.querySelector('meta[name="base-url"]')

if(base_url) {
    axios.defaults.baseURL = base_url.content;
} else {
    axios.defaults.baseURL = 'http://cts.test/';
}

Vue.prototype.$recaptchaKey = window.recaptchaKey;
Vue.prototype.$changeLanguage = function (lang) {
    changeLanguage(lang)
};
Vue.prototype.$vueEventBus = new Vue();
Vue.prototype.$fileLink = function (file) {
    return '/storage/'+file.uuid+'/'+file.file_name;
};

function loadComponent(path) {
    return () => import(/* webpackPrefetch: true */'./components/' + path);
}

Vue.component('login', loadComponent('Login.vue'));
Vue.component('register', loadComponent('Register.vue'));
Vue.component('contact-form', loadComponent('ContactForm.vue'));
Vue.component('input-with-validation', require('../admin/components/InputWithValidation.vue').default);
Vue.component('language-switcher', require('../admin/components/LanguageSwitcher').default);
Vue.component('cookie-consent', loadComponent('CookieConsent.vue'));
Vue.component('order-a-call', loadComponent('OrderACallForm.vue'));
Vue.component('password-reset-form', loadComponent('PasswordResetForm'));
Vue.component('email-verification-resend-form', loadComponent('EmailVerificationResendForm'));
Vue.component('privacy-policy-modal', loadComponent('PrivacyPolicyModal'));
Vue.component('front-swiper', loadComponent('FrontSwiper'));
Vue.component('reset-password-component', loadComponent('ResetPasswordComponent'));
Vue.component('check-mark', loadComponent('CheckMark'));
Vue.component('translate', Translate);
Vue.component('packs-component', require('../client/components/PacksComponent').default);

Vue.use(Notifications)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueCookies)

Vue.component('password', Password);

new Vue({
    data: {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    },
    router,
    store,
    i18n
}).$mount('#home');
